/**
 * Created by meirr on 9/11/16.
 */

/**
 * Base class for Filter Items
 * Filter Item is a single filter option in FilterFullTableViewController
 */
define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    /**
     * @implements {ViewController}
     */
    var BaseFilterItem = ViewController.extend({

        initialize: function (constructorData) {

        },
        events: function () {
        },
        render: function () {

        }
    });

    /**
     * get filter value
     * Should be overriden by extended filter items
     * @abstract
     * @return {String}
     */
    BaseFilterItem.prototype.getValue = function() {

    };

    /**
     * reset filter value
     * Should be overriden by extended filter items
     * @param filterData {Object} data
     * @abstract
     */
    BaseFilterItem.prototype.updateFilterUI = function(filterData) {

    };


    return BaseFilterItem;

});
